import { SCENE_IMAGES } from "../scene/scene";

/** The session's scene artwork (see `getScene`), dimmed behind the homepage. */
export default function HomeBackground({ scene }) {
  return (
    <div
      className="home-bg"
      aria-hidden="true"
      style={{ backgroundImage: `url("${SCENE_IMAGES[scene].hero}")` }}
    />
  );
}
